
import Component from 'vue-class-component';
import Vue from 'vue'
import { settingStore, menuStore } from '@/stores/index'
@Component
export default class SideMenu extends Vue {
    menu = menuStore();
    store = settingStore();

    handleClick(n: any) {
        const current = this.$route.name;
        if (current == n.name)
            return;
        this.menu.Open(n);
    }
}
